/**
 * Biker BFF API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CustomersRegisterPostRequest model module.
 * @module model/CustomersRegisterPostRequest
 * @version 1.0.0
 */
class CustomersRegisterPostRequest {
    /**
     * Constructs a new <code>CustomersRegisterPostRequest</code>.
     * @alias module:model/CustomersRegisterPostRequest
     * @param email {String} 
     * @param password {String} 
     * @param passwordConfirmation {String} 
     */
    constructor(email, password, passwordConfirmation) { 
        
        CustomersRegisterPostRequest.initialize(this, email, password, passwordConfirmation);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, email, password, passwordConfirmation) { 
        obj['email'] = email;
        obj['password'] = password;
        obj['passwordConfirmation'] = passwordConfirmation;
    }

    /**
     * Constructs a <code>CustomersRegisterPostRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomersRegisterPostRequest} obj Optional instance to populate.
     * @return {module:model/CustomersRegisterPostRequest} The populated <code>CustomersRegisterPostRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomersRegisterPostRequest();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('passwordConfirmation')) {
                obj['passwordConfirmation'] = ApiClient.convertToType(data['passwordConfirmation'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CustomersRegisterPostRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CustomersRegisterPostRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CustomersRegisterPostRequest.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }
        // ensure the json data is a string
        if (data['passwordConfirmation'] && !(typeof data['passwordConfirmation'] === 'string' || data['passwordConfirmation'] instanceof String)) {
            throw new Error("Expected the field `passwordConfirmation` to be a primitive type in the JSON string but got " + data['passwordConfirmation']);
        }

        return true;
    }


}

CustomersRegisterPostRequest.RequiredProperties = ["email", "password", "passwordConfirmation"];

/**
 * @member {String} email
 */
CustomersRegisterPostRequest.prototype['email'] = undefined;

/**
 * @member {String} password
 */
CustomersRegisterPostRequest.prototype['password'] = undefined;

/**
 * @member {String} passwordConfirmation
 */
CustomersRegisterPostRequest.prototype['passwordConfirmation'] = undefined;






export default CustomersRegisterPostRequest;

